import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { OfferType } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonSeventhVariantConfig } from '@shared/models';
import {
  AmountPipe,
  RewardPipe,
  SafePipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant7',
  styleUrl: './variant7.component.scss',
  templateUrl: './variant7.component.html',
  imports: [
    SafePipe,
    RewardPipe,
    AmountPipe,
    ButtonComponent,
    VariableReplacementPipe,
  ],
})
export class Variant7Component extends SelectionButtonBaseClass {
  protected readonly OfferType: typeof OfferType = OfferType;
  config = input.required<SelectionButtonSeventhVariantConfig>();
}
